module.exports = __webpack_public_path__ + "68c704c6fe9b3665bb197e452493fa30.png";